import { Controller } from '@hotwired/stimulus';

import { Tooltip } from 'bootstrap';

export default class TooltipController extends Controller {
  connect() {
    this.tooltip = new Tooltip(this.element);
  }

  disconnect() {
    this.tooltip.dispose();
  }
}
